import { Autocomplete, TextField } from '@mui/material';
import { useAdapterServiceKeys } from '../../hooks/useAdapterServices';

type Props = {
  value: string;
  onChange: (key: string) => void;
  disabled?: boolean;
};

export function AdapterServiceKeyField({ value, onChange, disabled }: Props) {
  const { data: keys = [], isLoading } = useAdapterServiceKeys();
  const options = keys.includes(value) || !value ? keys : [...keys, value];

  return (
    <Autocomplete
      freeSolo
      disabled={disabled}
      loading={isLoading}
      options={options}
      value={value}
      onChange={(_, v) => onChange(String(v ?? '').trim().toLowerCase())}
      onInputChange={(_, v) => onChange(v.trim().toLowerCase())}
      renderInput={params => (
        <TextField
          {...params}
          label="Service key"
          helperText="Runtime key for executeService and config:service:{key}. Pick existing or type a new key."
          required
        />
      )}
    />
  );
}
